import * as Yup from "yup";
import { KeyValueMap } from "../../../redux/slices/appState/models";

import { SystemMessageSearchFormKey } from "./models";

export const SearchSystemMessageSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [SystemMessageSearchFormKey.country]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
  });
